<template>
  <div class="relative grid grid-cols-12 min-h-svh bg-capino-light">
    <SigninFormCard
      v-if="isVisible.formCard"
      class="col-span-12 z-[1]"
      @open-verify-card="handleOpenVerifyCard"
    />

    <SigninVerifyCard
      v-if="isVisible.verifyCard"
      class="col-span-12 z-[1]"
      :email="form.email"
      @open-signin="handleOpenSignin"
    />

    <img
      src="/images/capybara-head-lightgray.png"
      class="absolute bottom-0 left-0 size-[200px] sm:size-[300px] opacity-50 rotate-[36deg] translate-x-[-100px] translate-y-[40px] pointer-events-none"
      loading="lazy"
      fetchpriority="high"
      style="filter: brightness(0.95)"
      alt="Capybara head illustration top left"
    />

    <!-- <div
      v-if="isVisible.video"
      class="relative col-span-6 h-full border-l max-lg:hidden"
    >
      <img
        src="/images/capybara-head-lightgray.png"
        class="absolute bottom-1/2 right-0 size-[200px] sm:size-[300px] opacity-50 rotate-[36deg] translate-x-[-100px] translate-y-[40px] pointer-events-none"
        loading="lazy"
        fetchpriority="high"
        style="filter: brightness(0.95)"
        alt="Capybara head illustration top left"
      />
    </div> -->
  </div>
</template>

<script>
import SigninFormCard from '@/components/Signin/SigninFormCard.vue'
import SigninVerifyCard from '@/components/Signin/SigninVerifyCard.vue'

export default {
  name: 'TheSignin',

  components: {
    SigninFormCard,
    SigninVerifyCard
  },

  data: () => ({
    isVisible: {
      formCard: true,
      verifyCard: false
      // video: true
    },

    form: {
      email: ''
    }
  }),

  mounted() {
    window?.datafast('signin-opened')
  },

  methods: {
    handleOpenSignin() {
      this.isVisible.formCard = true
      this.isVisible.verifyCard = false
    },

    handleOpenVerifyCard({ email }) {
      this.form.email = email

      this.isVisible.formCard = false
      this.isVisible.verifyCard = true
    }
  }
}
</script>
